export default __webpack_public_path__ + "static/media/Banner - AirCare Cleaning Kit.7f6bb85b.jpg";